(() => {
  document.addEventListener('click', event => {
    const check = event.target.closest('[data-sp-check-model]');
    if (!check) return;
    const root = check.closest('[id^="MainProduct-"]');
    const picker = [...(root?.querySelectorAll('[data-model-open]') || [])].find(node => node.getClientRects().length);
    picker?.click();
  });
})();
